import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';

@Component({
    selector: 'app-montant-operation',
    templateUrl: './montant-operation.component.html',
    styleUrls: ['./montant-operation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MontantOperationComponent extends AbstractSpecificFieldComponent<number> {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'montant';
  }

  override wrapData(value: string): number {
    return Number(value);
  }

  override markAsTouched(): void {
    this.control.markAsTouched();
  }
}
